import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });


//var flg;
let menuFlg = false;

$(document).on('click', '.menu-btn', function () {
  let $this = $(this);
  let $target = $this.next();
  $this.find('.menu-trigger').stop().toggleClass('active');

  if (menuFlg == false) {
    gsap.to($target, {
      right: 0,
      duration: 0.3,
      ease: "power2.inOut"
    });
    menuFlg = true;
  } else {

    gsap.to($target, {
      right: -53.8 + 'rem',
      duration: 0.3,
      ease: "power2.inOut"
    });
    menuFlg = false;
  }
  return false;
});

$(document).on('click', '.menu a', function () {
  $('.menu-trigger').stop().toggleClass('active');
  let $target = $('nav');
  gsap.to($target, {
    right: -53.8 + 'rem',
    duration: 0.3,
    ease: "power2.inOut"
  });
  menuFlg = false;
  return false;
});
